import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const InfoField = ({
  title,
  description,
  children,
  isEditing,
  onFieldChange,
  canEdit,
  hasChanges,
  multiline = false
}) => {
  // Detectar si children es JSX o texto simple
  const isJSX = React.isValidElement(children);
  const isMinusIcon =
    (isJSX && children.props?.className?.includes('fas fa-minus')) ||
    (typeof children === 'string' && children === 'fas fa-minus');

  // Solo usar localValue para texto simple
  const [localValue, setLocalValue] = useState(
    typeof children === 'string' ? children : ''
  );

  // Sincronizar localValue con children cuando cambie (solo para texto)
  useEffect(() => {
    if (typeof children === 'string') {
      setLocalValue(children);
    }
  }, [children]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    if (isEditing && canEdit) {
      setLocalValue(newValue);
      onFieldChange(newValue);
    }
  };

  return (
    <div className={`space-y-2 min-w-0 ${hasChanges ? 'field-modified' : ''}`}>
      <p className="text-sm sm:text-base font-semibold flex items-center gap-2 flex-wrap break-words">
        {title}
        {hasChanges && (
          <span
            className="badge badge-info ms-2"
            style={{ fontSize: '0.7rem' }}>
            Modified
          </span>
        )}
      </p>
      {description && (
        <p className="text-sm text-muted-foreground break-words">
          {description}
        </p>
      )}
      <div className="mt-2">
        {isEditing && canEdit ? (
          <>
            {multiline ? (
              <textarea
                value={localValue}
                onChange={handleInputChange}
                rows={4}
                className={`form-control text-sm w-full ${
                  hasChanges ? 'border-warning' : ''
                }`}
                style={{
                  minHeight: '120px',
                  resize: 'vertical',
                  width: '100%'
                }}
                placeholder={isMinusIcon ? 'Enter description...' : ''}
              />
            ) : (
              <input
                type="text"
                value={localValue}
                onChange={handleInputChange}
                className={`form-control text-sm w-full ${
                  hasChanges ? 'border-warning' : ''
                }`}
                style={{ width: '100%' }}
                placeholder={isMinusIcon ? 'Enter value...' : ''}
              />
            )}
          </>
        ) : (
          <div className="text-sm sm:text-base break-words">
            {isJSX ? (
              // Renderizar JSX directamente
              children
            ) : localValue && localValue !== '' ? (
              <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {localValue}
              </span>
            ) : (
              <i className="fas fa-minus"></i>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

InfoField.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.string,
  children: PropTypes.node,
  isEditing: PropTypes.bool,
  onFieldChange: PropTypes.func,
  canEdit: PropTypes.bool,
  hasChanges: PropTypes.bool,
  multiline: PropTypes.bool
};

InfoField.defaultProps = {
  isEditing: false,
  canEdit: true,
  hasChanges: false,
  multiline: false
};

export default InfoField;
